document.addEventListener("turbolinks:before-cache", function() {
  $('.slick-initialized').slick('unslick');
})
